import * as React from 'react';
import { Component, ComponentClass, PropTypes, ValidationMap } from 'react';
import { Dispatch, Store } from 'redux';

export interface IStateMapper<TState, TParentProps, TChildProps> {
  (state?: TState, dispatch?: Dispatch<TState>, parentProps?: TParentProps): TChildProps;
}

export default function connectState<TState, TParentProps, TChildProps>
(mapper: IStateMapper<TState, TParentProps, TChildProps>) {
  return (DecoratedComponent: ComponentClass<TChildProps>): ComponentClass<TParentProps> => {
    return class extends Component<TParentProps, void> {
      public static displayName = `connectState(${DecoratedComponent.name})`;

      /* tslint:disable:no-any */
      public static contextTypes = {
        store: PropTypes.object.isRequired,
      } as ValidationMap<any>;
      /* tslint:enable:no-any */

      public context: {
        store: Store<TState>;
      };
      private unsubscribe: () => void;

      public componentDidMount() {
        this.unsubscribe = this.context.store.subscribe(() => {
          this.forceUpdate();
        });
      }

      public componentWillUnmount() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = undefined;
        }
      }

      public render() {
        const childProps = mapper(this.context.store.getState(), this.context.store.dispatch, this.props);

        return (
          <DecoratedComponent {...childProps} />
        );
      }
    };
  };
}



// WEBPACK FOOTER //
// ./src/utils/connect_state.tsx